import { Link } from 'react-router-dom';
import { APP_VERSION } from '@apartment-booking/shared';

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8">
          <Link to="/login" className="text-primary-600 hover:text-primary-700">
            &larr; Back to Login
          </Link>
        </div>

        <div className="bg-white shadow rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Support</h1>

          <div className="space-y-8">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">About Apartment 5H</h2>
              <p className="text-gray-600">
                Apartment 5H is a private booking application designed for family and friends to
                coordinate access to a shared vacation apartment. The app allows authorized users
                to view availability, request bookings, and access property information.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Getting Started</h2>
              <div className="text-gray-600 space-y-3">
                <p>
                  <strong>Account Access:</strong> Apartment 5H is a private, invitation-only app.
                  If you need access, please contact the property administrator to receive an invitation.
                </p>
                <p>
                  <strong>Logging In:</strong> Use the email address and password from your invitation
                  to sign in. On iOS, you can also enable Face ID for faster access.
                </p>
                <p>
                  <strong>Making Bookings:</strong> View the calendar to check availability, then
                  select your desired dates to submit a booking request. An administrator will
                  approve your request.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Frequently Asked Questions</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="font-medium text-gray-900">How do I reset my password?</h3>
                  <p className="text-gray-600 mt-1">
                    Click "Forgot password?" on the login page and enter your email address.
                    You'll receive a link to reset your password.
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">How do I cancel a booking?</h3>
                  <p className="text-gray-600 mt-1">
                    Go to "My Bookings" to view your upcoming reservations. Contact the property
                    administrator if you need to cancel or modify a booking.
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">How do I enable Face ID login?</h3>
                  <p className="text-gray-600 mt-1">
                    On the iOS app, go to your profile settings and enable biometric authentication.
                    You'll need to verify your password once to set it up.
                  </p>
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">Who can see my bookings?</h3>
                  <p className="text-gray-600 mt-1">
                    All authorized users of the apartment can see booking dates and names on the
                    calendar to help coordinate schedules.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">Contact Us</h2>
              <p className="text-gray-600 mb-4">
                For questions, issues, or feedback about the app, please contact us:
              </p>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-gray-700">
                  <strong>Email:</strong>{' '}
                  <a
                    href="mailto:support@5h.hellers.com"
                    className="text-primary-600 hover:text-primary-700"
                  >
                    support@5h.hellers.com
                  </a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">App Information</h2>
              <div className="bg-gray-50 rounded-lg p-4 space-y-2 text-gray-600">
                <p><strong>App Name:</strong> Apartment 5H</p>
                <p><strong>Platform:</strong> iOS, Web</p>
                <p><strong>Version:</strong> {APP_VERSION}</p>
              </div>
            </section>

            <div className="pt-4 border-t border-gray-200">
              <Link to="/privacy" className="text-primary-600 hover:text-primary-700">
                View Privacy Policy &rarr;
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
